// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-cases{height:calc(100vh - 160px);position:relative;width:100%}.height-auto{height:auto!important;overflow:initial!important;width:100%}.v-align-center.icon{vertical-align:bottom}.select-state{position:relative;top:12px}.box-tip{border-radius:8px;margin:8px 16px;min-height:100px;width:100%}.box-tip table td{color:#8a8a8a}.ps{margin-top:0;height:calc(100vh - 170px)}@media screen and (max-width:599px){.list-cases{height:auto;min-height:calc(100vh - 160px)}}", ""]);
// Exports
module.exports = exports;
